import axios from "axios";
import { attachTokenRefreshInterceptors } from "../Utils/authTokenRefresh";

const searchAxios = axios.create({
  baseURL: process.env.REACT_APP_SEARCH_API_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json, text/plain",
  },
});

attachTokenRefreshInterceptors(searchAxios);

/** Spaces as %20 (not +) in query strings — matches e.g. searchString=new%20India */
function serializeParamsPercent20(params) {
  return Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([key, value]) => {
      const enc = encodeURIComponent(String(value));
      return `${encodeURIComponent(key)}=${enc}`;
    })
    .join("&");
}

export const searchAPI = {
  // searchLocation: async (searchText) => {
  //   try {
  //     const response = await searchAxios.post("/api/Location/FindLocation", {
  //       serachText: searchText
  //     });
  //     return response.data;
  //   } catch (error) {
  //     console.error("Search location error:", error);
  //     throw error;
  //   }
  // },
  searchLocation: async (searchText) => {
    try {
      const response = await searchAxios.get("/api/Location/search", {
        params: {
          searchString: searchText
        },
        paramsSerializer: serializeParamsPercent20
      });
      return response.data;
    } catch (error) {
      console.error("Search location error:", error);
      throw error;
    }
  },
  
  searchHotels: async (params) => {
    try {
      const response = await searchAxios.post("/api/Hotel/search", params);
      return response.data;
    } catch (error) {
      console.error("Search hotels error:", error);
      throw error;
    }
  },
  getHotelDetails: async (payload) => {
    
    try {
      const response = await searchAxios.post("/api/Hotel/itinerary", payload);
        return response.data;

    } catch (error) {
      console.error("Error fetching hotel details:", error);
      throw error; // Re-throw the error to be handled by the caller
    }
  },
  selectRoom: async (payload) => {
    try {
      const response = await searchAxios.post("/api/Room/SelectRoom", payload);
      return response.data;
    } catch (error) {
      console.error("Error selecting room:", error);
      throw error;
    }
  },
  /** POST /api/Hotel/itinerary/{itineraryCode}/select - select room from itinerary response, then go to payment */
  selectItineraryRoom: async (itineraryCode, payload) => {
    try {
      const response = await searchAxios.post(
        `/api/Hotel/itinerary/${itineraryCode}/select`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error selecting itinerary room:", error);
      throw error;
    }
  },
  /** POST /api/Hotel/itinerary/{itineraryCode}/allocate - assign guests after guest-detail step */
  allocateItineraryGuests: async (itineraryCode, payload) => {
    try {
      const response = await searchAxios.post(
        `/api/Hotel/itinerary/${itineraryCode}/allocate`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error allocating itinerary guests:", error);
      throw error;
    }
  },
  /** POST /api/Hotel/itinerary/details - full itinerary for review booking page */
  getHotelItineraryDetails: async (payload) => {
    try {
      const response = await searchAxios.post(
        "/api/Hotel/itinerary/details",
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching hotel itinerary details:", error);
      throw error;
    }
  },
  /** POST /api/Hotel/order/create-order-from-itinerary — create order before payment */
  createOrderFromItinerary: async (payload) => {
    try {
      const response = await searchAxios.post(
        "/api/Hotel/order/create-order-from-itinerary",
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error creating order from itinerary:", error);
      throw error;
    }
  },
  /** GET /api/PaymentMode — list payment options (HDFC, PhonePe, etc.) */
  getPaymentModes: async () => {
    try {
      const response = await searchAxios.get("/api/PaymentMode");
      return response.data;
    } catch (error) {
      console.error("Error fetching payment modes:", error);
      throw error;
    }
  },
  /** POST /api/Payment/initiate — start payment (e.g. HDFC payment page) */
  initiatePayment: async (payload) => {
    try {
      const response = await searchAxios.post("/api/Payment/initiate", payload);
      return response.data;
    } catch (error) {
      console.error("Error initiating payment:", error);
      throw error;
    }
  },
  /** GET /api/Payment/status/{orderId}?pgName=… — e.g. pgName=wallet for wallet flow */
  getPaymentOrderStatus: async (orderId, pgName) => {
    try {
      const encoded = encodeURIComponent(String(orderId));
      const trimmed = pgName != null ? String(pgName).trim() : "";
      const config =
        trimmed !== ""
          ? { params: { pgName: trimmed } }
          : {};
      const response = await searchAxios.get(
        `/api/Payment/status/${encoded}`,
        config
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching payment order status:", error);
      throw error;
    }
  },
  /** POST /api/Hotel/itinerary/{itineraryCode}/book — confirm booking after successful payment */
  bookItinerary: async (itineraryCode, payload) => {
    try {
      const enc = encodeURIComponent(String(itineraryCode));
      const response = await searchAxios.post(
        `/api/Hotel/itinerary/${enc}/book`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error booking itinerary:", error);
      throw error;
    }
  },
  getItinerary: async (payload) => {
    try {
      const response = await searchAxios.post("/api/Iteinerary/GetItinerary", payload);
      return response.data;
    } catch (error) {
      console.error("Error fetching itinerary:", error);
      throw error;
    }
  },
  getCoupons: async () => {
    try {
      const response = await searchAxios.get("/api/Coupon/GetCoupon");
      return response.data;
    } catch (error) {
      console.error("Error fetching coupons:", error);
      throw error;
    }
  },
  applyCoupon: async (payload) => {
    try {
      const response = await searchAxios.post("/api/coupon/ApplyCoupon", payload);
      return response.data;
    } catch (error) {
      console.error("Error applying coupon:", error);
      throw error;
    }
  },
  paymentStatus: async (payload) => {
    try {
      const response = await searchAxios.post("/api/payment/status", payload);
      return response.data;
    } catch (error) {
      console.error("Error checking payment status:", error);
      throw error;
    }
  },
  bookingOrder: async (payload) => {
    try {
      const response = await searchAxios.post("/api/Order/BookingOrder", payload);
      return response.data;
    } catch (error) {
      console.error("Error creating booking order:", error);
      throw error;
    }
  },
  confirmPayment: async (orderId, pgName) => {
    try {
      const response = await searchAxios.get(`/api/Payment/ConfirmPayment`, {
      params: {
        orderId: orderId,
        pgName: pgName
      }
      });
      return response.data;
    } catch (error) {
      console.error("Error confirming payment:", error);
      throw error;
    }
  },
  getBookingList: async (payload) => {
    try {
      const response = await searchAxios.post("/api/Customer/BookingList", payload);
      return response.data;
    } catch (error) {
      console.error("Error fetching booking list:", error);
      throw error;
    }
  },
  /** GET /api/Booking/user/{userId}?pageNumber=&pageSize= — paginated bookings for user */
  getBookingsByUser: async (userId, pageNumber = 1, pageSize = 10) => {
    try {
      const id = encodeURIComponent(String(userId));
      const response = await searchAxios.get(`/api/Booking/user/${id}`, {
        params: { pageNumber, pageSize },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching user bookings:", error);
      throw error;
    }
  },
  /** GET /api/Booking/client/{clientId}?pageNumber=&pageSize= — all bookings for B2B client (admin) */
  getBookingsByClient: async (clientId, pageNumber = 1, pageSize = 10) => {
    try {
      const id = encodeURIComponent(String(clientId));
      const response = await searchAxios.get(`/api/Booking/client/${id}`, {
        params: { pageNumber, pageSize },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching client bookings:", error);
      throw error;
    }
  },
  /** GET /api/Booking/client/{clientId}/user/{userId}?pageNumber=&pageSize= — one user's bookings under client */
  getBookingsByClientUser: async (clientId, userId, pageNumber = 1, pageSize = 10) => {
    try {
      const cid = encodeURIComponent(String(clientId));
      const uid = encodeURIComponent(String(userId));
      const response = await searchAxios.get(
        `/api/Booking/client/${cid}/user/${uid}`,
        { params: { pageNumber, pageSize } }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching client user bookings:", error);
      throw error;
    }
  },
  cancelBooking: async (orderId) => {
    try {
      const response = await searchAxios.get(`/api/Customer/CancelBooking?OrderId=${orderId}`);
      return response.data;
    } catch (error) {
      console.error("Error canceling booking:", error);
      throw error;
    }
  },
  /** POST /api/Hotel/booking/{bookingId}/cancel — hotel booking cancel (B2B history) */
  cancelHotelBookingById: async (bookingId) => {
    try {
      const id = encodeURIComponent(String(bookingId));
      const response = await searchAxios.post(`/api/Hotel/booking/${id}/cancel`);
      return response.data;
    } catch (error) {
      console.error("Error canceling hotel booking:", error);
      throw error;
    }
  },
  getBookingDetails: async (orderId) => {
    try {
      const response = await searchAxios.get(`/api/Customer/BookingDetails?OrderId=${orderId}`);
      // const response = await searchAxios.get(`/api/Customer/BookingDetails?OrderId=20250605081602950673`);
      return response.data;
    } catch (error) {
      console.error("Error fetching booking details:", error);
      throw error;
    }
  },
  /** POST /api/Hotel/booking/complete-details — B2B booking summary for history "View" */
  getBookingCompleteDetails: async (payload) => {
    try {
      const response = await searchAxios.post(
        "/api/Hotel/booking/complete-details",
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching booking complete details:", error);
      throw error;
    }
  },
};